import { useStore } from "@state/store"
import { useEffect } from "react"
import styled from "styled-components/macro"
import { useProjectDataStore } from "@state/projectDataStore"
import InfoLayout from "./components/InfoLayout"
import gsap from "gsap"
import { info2Data } from "./info2Data"

const Info2 = () => {
  const contentControls = useStore((s) => s.contentControls)

  const { brandingData } = useProjectDataStore((s) => ({
    brandingData: s.brandingData,
  }))

  const bgImage = "/assets/imgs/bg2.jpg"

  useEffect(() => {
    gsap.to(".first", {
      autoAlpha: contentControls?.index === 0 ? 1 : 0,
      duration: 0.6,
      ease: "power3.inOut",
    })
    gsap.to(".second", {
      autoAlpha: contentControls?.index === 1 ? 1 : 0,
      duration: 0.6,
      ease: "power3.inOut",
    })
    gsap.to(".third", {
      autoAlpha: contentControls?.index === 2 ? 1 : 0,
      duration: 0.6,
      ease: "power3.inOut",
    })
  }, [contentControls])

  return (
    <Info2Wrapper bgImage={bgImage}>
      <InfoLayout className="first" info1Data={info2Data?.sections[0]} />
      <InfoLayout className="second" info1Data={info2Data?.sections[1]} />
    </Info2Wrapper>
  )
}

export default Info2

const Info2Wrapper = styled.div<{ bgImage }>`
  width: 100%;
  z-index: 99999;
  height: 100%;
  background-image: url(${(props) => props.bgImage});
  background-size: cover;
  display: flex;

  .second,
  .third {
    opacity: 0;
  }
`
